<template lang="pug">
  .component.component-backoffice-driver-notification
      ModalReveal.p-0.m-0
        a.pr-2.fa.fa-send-o(slot="trigger")
        label Send Notification
          form(@submit.prevent="pushNotification")
            input(type="text", v-model="body.subject" placeholder='subject')
            textarea(v-model="body.content" rows=6 placeholder='content')
            input(type="text", v-model="body.url" placeholder='https url')
          ActionButton(:action="pushNotification") Send

</template>
<script type="text/babel">
import {mapState} from 'vuex'
import ModalReveal from "../structure/foundation/ModalReveal";
import LoadingSpinner from "../structure/LoadingSpinner";
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
import ActionButton from "../structure/ui/ActionButton";
import MaggieHelper from "../../maggieHelper";

export default {
  name: 'DriverNotification',
  components: {
    ActionButton,
    LoadingSpinner,
    ModalReveal

  },
  data() {
    return {
      body: {
        subject: null,
        url: "",
        content: null,
        driver_id: this.driver_id,
        type: 'App\\Models\\Driver'
      },
      loading: false,
      items: null
    }
  },

  methods: {

    pushNotification() {
      return KeplerBackofficeSdk.drivers.sendNotification(this.body, (data) => MaggieHelper.notification(data.result))
    }
  },

  props: {
    driver_id: {
      required: true
    },
    type: {
      type: String,
      default: ''
    }
  },
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component.component-backoffice-driver-notes
  .description
    white-space: pre
</style>



// WEBPACK FOOTER //
// DriverNotification.vue?164ad43f